import React from 'react';
import { Box, Typography, Card, CardContent } from '@mui/material';

const Settings: React.FC = () => {
  return (
    <Box>
      <Typography variant="h4" component="h1" gutterBottom fontWeight={600}>
        Settings
      </Typography>
      <Typography variant="body1" color="textSecondary" mb={3}>
        Configure application settings and integrations.
      </Typography>

      <Card>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Application Configuration
          </Typography>
          <Typography variant="body2" color="textSecondary">
            This feature is coming soon. You'll be able to configure:
          </Typography>
          <Box component="ul" sx={{ mt: 2, pl: 3 }}>
            <li>Google Sheets integration settings</li>
            <li>WhatsApp API configuration</li>
            <li>Reminder schedule and templates</li>
            <li>Hostel information and contact details</li>
            <li>User management and permissions</li>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default Settings;